import { BaseService } from './base.service';
import { LoginUserPayload, SignupUserPayload } from '../models/service.models';

export default class AuthenticationService extends BaseService {
  public async loginUser(payload: LoginUserPayload) {
    return this.axios.post(`${this.backendUrl}/login`, payload);
  }

  public async signupUser(payload: SignupUserPayload) {
    return this.axios.post(`${this.backendUrl}/signup`, payload);
  }

  public async resetPassword(email: string) {
    return this.axios.post(`${this.backendUrl}/reset-password`, { email });
  }

  public async validateResetPasswordLink(token: string) {
    return this.axios.post(`${this.backendUrl}/validate-reset-password-link`, {
      token,
    });
  }

  public async resetPasswordFromLink(token: string, password: string) {
    return this.axios.post(`${this.backendUrl}/update-password-from-link`, {
      token,
      password,
    });
  }

  public async authorize(token: string) {
    return this.axios.post(
      `${this.backendUrl}/authorize`,
      {},
      {
        headers: {
          'x-access-token': token,
        },
      }
    );
  }
}
